import { render, staticRenderFns } from "./PropertiesFilters.vue?vue&type=template&id=79ef8965&scoped=true&"
import script from "./PropertiesFilters.vue?vue&type=script&lang=js&"
export * from "./PropertiesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef8965",
  null
  
)

export default component.exports